<template>
  <div class="editPanel">
    <div class="toolbar-container">
        <svg-icon
          v-for="(icon, key) in tools"
          :key="key"
          class="icon"
          :class="[
            'can' in icon && !icon.can ? 'disabled' : 'enabled',
            { freeze: icon.freeze },
          ]"
          :icon-class="icon.svg"
          :title="icon.title"
          @click="handleTrigger(icon.svg)"
        />
    </div>
    <div class="content-container">
        <b-ace-editor :value="value" :readonly="disabled" :snippets="true" :theme="theme" :height="height"  :options="editorOptions" @init="editorInit" @input="$emit('input', $event)" :lang="lang"> </b-ace-editor>
        <a-alert v-show="showError" :message="msg" type="error" closable @close="onClose" />
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import Editor from 'bin-ace-editor';
import SvgIcon from "../x6/components/SvgIcon.vue";
import { parseFlinkSql, parseDorisSql } from '@/services/sql';
Vue.component(Editor.name, Editor);
export default {
  components: { SvgIcon },
  props: {
    lang: {
      type: String
    },
    value: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: '450'
    }
  },
  data() {
    return {
      showError: false,
      current: 0,
      theme: 'solarized_light',
      editorOptions: {
					// 设置代码编辑器的样式
					enableBasicAutocompletion: true, //启用基本自动完成
					enableSnippets: true, // 启用代码段
					enableLiveAutocompletion: true, //启用实时自动完成
					tabSize: 2, //标签大小
					fontSize: 16, //设置字号
					showPrintMargin: false //去除编辑器里的竖线
			},
      themeList: [
          'chrome',
          'clouds',
          'dracula',
          'solarized_light',
          'solarized_dark',
      ],
      tools: {
        save: {
          svg: "save",
          title: "保存",
        },
        submit: {
          svg: "submit",
          //can: false,
          title: "提交",
        },
        stop: {
          svg: "stop",
          //can: false,
          title: "停止",
        },
        run: {
          svg: "run",
          title: "运行",
        },
        format: {
          svg: "format",
          title: "格式化",
        },
        check: {
          svg: "check",
          title: "语法检查",
        },
        theme: {
          svg: "theme",
          title: "变换模式",
        },
      },
    };
  },
  methods: {
    editorInit() {
				require('brace/theme/chrome');
        require('brace/theme/clouds');
        require('brace/theme/solarized_light');
        require('brace/theme/solarized_dark');
        require('brace/theme/dracula');
				require('brace/ext/language_tools'); //language extension prerequsite...
				require('brace/mode/yaml');
				require('brace/mode/json');
				require('brace/mode/less');
				require('brace/snippets/json');
				require('brace/mode/javascript');
				require('brace/snippets/javascript');
				require('brace/mode/python');
				require('brace/snippets/python');
				require('brace/mode/sql');
				require('brace/snippets/sql');
				require('brace/mode/sh');
				require('brace/snippets/sh');
		},
    async formatSql() {
      if (this.lang.indexOf('sql') == -1) return; 
      let res;
      if (this.lang === 'flinksql') {
        res = await parseFlinkSql(this.value);
      } else if (this.lang === 'dorissql') {
        res = await parseDorisSql(this.value);
      }
    
      let { header } = res;
      if (header.code == 500) {
        this.$message.error('存在语法错误，请先进行语法检查！');
      } else {
        //this.value = res.payload.join('\n');
        if (this.lang === 'flinksql') {
          this.$emit('input', res.payload.join('\n'));
        } else if (this.lang === 'dorissql') {
          this.$emit('input', res.payload);
        }
      }
    },
    async checkSql() {
      if (this.lang.indexOf('sql') == -1) return; 
      this.showError = false;
      this.msg = '';
      let res;
      if (this.lang === 'flinksql') {
        res = await parseFlinkSql(this.value);
      } else if (this.lang === 'dorissql') {
        res = await parseDorisSql(this.value);
      }
      debugger
      let { header } = res;
      if (header.code == 500) {
        this.showError = true;
        this.msg = header.msg;
      } else {
        this.$message.success('语法正确');
      }
    },
    switchTheme() {
      this.current ++;
      if (this.current == 5) {
        this.current = 0;
      }
      // let r = Math.floor(Math.random()*5);
      this.theme = this.themeList[this.current];
    },
    onClose() {
      this.showError = false;
    },
    handleTrigger(name) {
      switch (name) {
        case "run":
          this.$emit('run');
          //this.tools.stop.can = true;
          break;
        case "stop":
          this.$emit('stop');
          break;
        case "save":
          this.$emit('save');
          //this.tools.submit.can = true;
          break;
        case "submit":
          this.$emit('submit');
          break;
        case "format":
          this.formatSql();
          break;
        case "check":
          this.checkSql();
          break;
        case "theme":
          this.switchTheme();
          break;
        default:
          break;
      }
    },
  }
};
</script>
<style lang="less">
.editPanel {
  flex-grow: 1;
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
}
.toolbar-container {
  position: absolute;
  width: 100%;
  height: 36px!important;
  z-index: 999;
  overflow: visible;
  background-color: #fff;
  //box-shadow: gray 0px 0px 10px;

  .icon {
    margin: 9px 20px;
    font-size: 1.8px;
  }
  .enabled {
    cursor: pointer;
    transition: all 0.2s;
    color: #666;
    &:hover {
      transform: scale(1.1);
      color: #333;
    }
    &:active {
      transform: scale(0.9);
    }
  }
  .disabled {
    cursor: not-allowed;
    transition: none;
    color: #999;
    &:hover {
      transform: none;
      color: #999;
    }
    &:active {
      transform: none;
    }
  }
}
.content-container {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: calc(100hv - 41px);
  padding: 0;
  margin-top: 36px;
  overflow: hidden;
  background: #f6f6f6;
}
</style>